import { format } from "date-fns";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatGBP } from "@/lib/api";
import { toast } from "sonner";

const Badge = ({ children }) => (
  <span className="rounded-full bg-[#FF6A00]/10 px-2.5 py-1 text-xs font-semibold text-[#FF8a3d]">{children}</span>
);

const Wrap = ({ children, testid }) => (
  <div className="overflow-x-auto rounded-2xl border border-[#262626]" data-testid={testid}>{children}</div>
);

export const DeliveriesTable = ({ rows }) => (
  <Wrap testid="deliveries-table">
    <Table className="min-w-[480px]">
      <TableHeader><TableRow className="border-[#262626] hover:bg-transparent"><TableHead>Date</TableHead><TableHead>Reference</TableHead><TableHead>Plan</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
      <TableBody>
        {rows.map((r) => (
          <TableRow key={r.id} className="border-[#1f1f1f]">
            <TableCell>{format(r.date, "d MMM yyyy")}</TableCell>
            <TableCell className="text-[#A1A1AA]">{r.id}</TableCell>
            <TableCell>{r.plan}</TableCell>
            <TableCell><Badge>{r.status}</Badge></TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Wrap>
);

export const PaymentsTable = ({ rows, demo = true }) => (
  <Wrap testid="payments-table">
    <Table className="min-w-[520px]">
      <TableHeader><TableRow className="border-[#262626] hover:bg-transparent"><TableHead>Date</TableHead><TableHead>Invoice</TableHead><TableHead>Amount</TableHead><TableHead>Status</TableHead><TableHead /></TableRow></TableHeader>
      <TableBody>
        {rows.map((r) => (
          <TableRow key={r.id} className="border-[#1f1f1f]">
            <TableCell>{format(r.date, "d MMM yyyy")}</TableCell>
            <TableCell className="text-[#A1A1AA]">{r.label || r.id}</TableCell>
            <TableCell className="font-semibold">{formatGBP(r.amount)}</TableCell>
            <TableCell><Badge>{r.status}</Badge></TableCell>
            <TableCell>
              {r.url ? (
                <a href={r.url} target="_blank" rel="noreferrer" className="text-sm text-[#FF6A00] hover:underline" data-testid={`invoice-view-${r.id}`}>View</a>
              ) : demo && (
                <button className="text-sm text-[#FF6A00] hover:underline" onClick={() => toast("Receipts appear here in your real account.")} data-testid={`invoice-view-${r.id}`}>
                  View
                </button>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Wrap>
);
